import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/eval/error-404')({
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <div className="noti-box__outer">
            <div className="noti-box noti-style3">
                <p className="noti-box__txt2">페이지를 찾을 수 없습니다.</p>
                <p className="noti-box__txt3 con-mt2">
                    요청하신 페이지는 존재하지 않거나 삭제된 경우입니다.
                    <br />
                    주소를 확인하시고 다시 시도해 주세요
                </p>
                {/* <p className="noti-box__txt3 con-mt2">메인 화면으로 돌아가려면 <b><a href="#" className="point-color">[여기]</a></b>를 클릭하세요.</p> */}

                <div className="noti-box__contact con-mt4">
                    <p className="tel">
                        비바샘 고객센터 : <b>1544-7714</b>
                    </p>
                </div>
            </div>
        </div>
    );
}
